import { VoiceEngineV2 } from '../VoiceEngineV2';
import { recordVoiceDiagnostic } from '../voiceDiagnostics';

/** Browser/PWA provider. It intentionally preserves VoiceEngineV2 unchanged. */
export class WebVoiceProvider extends VoiceEngineV2 {
  constructor(options = {}) {
    super({ ...options, voiceProvider: 'web_speech' });
    recordVoiceDiagnostic('provider_selected', { provider: 'web_speech', platform: 'web' });
  }

  get capabilities() {
    const supported = typeof window !== 'undefined'
      && Boolean(window.SpeechRecognition || window.webkitSpeechRecognition);
    return {
      native: false,
      microphone: typeof navigator !== 'undefined' && Boolean(navigator.mediaDevices?.getUserMedia),
      stt: supported,
      continuous: supported,
      bargeIn: true,
      tts: true,
      provider: 'web_speech',
    };
  }

  getCapabilities() { return this.capabilities; }
  startListening({ mode = 'manual' } = {}) { return mode === 'continuous' ? this.startActive() : this.startManual(); }
  stopListening() { return this._manualMode ? this.finishManual() : this.finishActive(); }
  cancelListening() { return this.setIdle(); }
  stopSpeaking() { return this.cancelSpeaking('speech_interrupted'); }
  bargeIn() { return this.beginBargeIn(); }
}

export default WebVoiceProvider;
